import React from 'react';
import {t} from '@lingui/core/macro';

import HttpIncident from 'features/http/ui/HttpIncident/HttpIncident/HttpIncident';
import MainModal from 'shared/ui/Modal/MainModal';
import IHttpIncident from 'features/http/model/HttpIncident/IHttpIncident';
import {getFormattedDate} from 'shared/lib/datetime';
import {isTranslate} from 'shared/lib/lang';

import IncidentStatus from '../../../../../shared/ui/Status/IncidentStatus';

import styles from './HttpIncidentModal.module.scss';

interface IHttpIncidentModalProps {
    open: boolean,
    item: IHttpIncident,
    handleClose: () => void,
    tzString?: string | null,
}

const HttpIncidentModal: React.FC<IHttpIncidentModalProps> = ({
    open,
    item,
    handleClose,
    tzString,
}) => {
    const problemStatus = !item.resolved;

    return (
        <MainModal
            dialogClassName={problemStatus ? styles.backgroundModal : undefined}
            headerClassName={styles.header}
            header={
                <div>
                    <div className={styles.contentHeader}>
                        {t`Инцидент монитора`}
                        <span className={styles.title}> - {item.monitor.name}</span>
                    </div>
                    <div className={styles.contentInfo}>
                        <div className={styles.monitorNameMobile}>
                            <span>{t`Монитор`}</span>
                            <span>{item.monitor.name}</span>
                        </div>
                        <div className={styles.itemInfo}>
                            <span className={styles.title}>{t`Статус`}</span>
                            <div className={styles.containerStatus}>
                                <IncidentStatus
                                    resolved={item.resolved}
                                    incompleteFail={item.incomplete_fail}
                                    incompleteSuccess={item.incomplete_success}
                                />
                                <span className={problemStatus ? styles.problem : styles.normal}>
                                    {problemStatus ? t`Не решён` : t`Решён`}
                                </span>
                            </div>
                        </div>
                        <div className={styles.itemInfo}>
                            <span className={styles.title}>{t`Дата возникновения`}</span>
                            <div className={styles.data}>
                                {getFormattedDate(
                                    item.created_at,
                                    {format: !isTranslate() ? 'DD.MM.YYYY, в HH:mm' : 'YYYY-MM-DD, in HH:mm', tzString},
                                )}
                            </div>
                        </div>
                        <div className={styles.itemInfo}>
                            <span className={styles.title}>{t`Длительность`}</span>
                            <div className={styles.data}>
                                {item.duration_formatted}
                            </div>
                        </div>
                        <div className={styles.itemInfo}>
                            <span className={styles.title}>{t`Дата решения`}</span>
                            <div className={styles.data}>
                                {getFormattedDate(
                                    item.resolved_at,
                                    {format: !isTranslate() ? 'DD.MM.YYYY, в HH:mm' : 'YYYY-MM-DD, in HH:mm', tzString},
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            }
            open={open}
            handleClose={handleClose}
            size="md"
        >
            <HttpIncident item={item} />
        </MainModal>
    );
};

export default HttpIncidentModal;